// extracted by mini-css-extract-plugin
module.exports = {"background":"_base-section-background-22601f2f4f572fdea89968268dff33dc"};